/** 
 * Curated location zone IDs.
 * These represent specific zones where special service rules may apply.
 */
export enum CuratedLocationZone {
    /** Sydney Airport - Zone 76 */
    SYDNEY_AIRPORT = 76,
    
    // Add more zones here as needed
    // MELBOURNE_AIRPORT = 2,
}

/** Zones where standard Silver Service is not available (only Silver Service Exec) */
export const ZONES_EXCLUDING_STANDARD_SILVER_SERVICE: CuratedLocationZone[] = [
    CuratedLocationZone.SYDNEY_AIRPORT
];
